/** Disparado após despesa paga no caixa ou mudança de status que afeta o consolidado. */
export const CASH_FLOW_INVALIDATE_EVENT = 'fv:cash-flow-invalidate';

export function dispatchCashFlowInvalidate() {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(CASH_FLOW_INVALIDATE_EVENT));
}
